import { DEFAULT_LANGUAGE_CODE, VALID_LANGUAGE } from "@nf/constants";

/**
 * Get the primary language for a given country.
 * "Primary" is defined as the first entry in VALID_LANGUAGE for that country.
 */
export function getPrimaryLanguage(country: string): string {
  const primaryLanguage =
    VALID_LANGUAGE[country.toLowerCase() as keyof typeof VALID_LANGUAGE]?.[0];
  return primaryLanguage || DEFAULT_LANGUAGE_CODE;
}
